import React from 'react';

interface CheckboxFieldProps {
    id: string;
    name: string;
    label: string;
    value: boolean;
    onChange: (name: string, value: boolean) => void;
    error?: string | boolean;
    containerClass?: string;
    style?: React.CSSProperties;
}

// eslint-disable-next-line react/display-name
export default ({
    id,
    name,
    label,
    value,
    onChange,
    error,
    containerClass = 'col-12 text-left pt-3',
    style = {},
}: CheckboxFieldProps) => (
    <div className={containerClass} style={style}>
        <input
            type="checkbox"
            id={id}
            name={name}
            checked={value}
            onChange={(e) => onChange(name, e.target.checked)}
        />

        <label htmlFor={id} className="ml-2">
            {label}
        </label>

        {error && (
            <div className="row">
                <label className="alert-danger m-auto">{error}</label>
            </div>
        )}
    </div>
);
